module.exports = __webpack_public_path__ + "img/stopped.d6a5c964.svg";